import React, { useState } from 'react'

export const SPOCProfileHeader = ({ SPOCProfileDetails }) => {
    const SPOCProfileDetail = (SPOCProfileDetails?.user[0])
    return (
        <div className="flex items-center justify-between gap-4 py-4">
            <div className="flex flex-col flex-1">
                <div className="flex flex-row gap-2">
                    <p className=' text-2xl font-semibold justify-center py-1 '>
                        {SPOCProfileDetail?.firstName ? ` ${SPOCProfileDetail?.firstName} ${SPOCProfileDetail?.lastName || ''}` : 'New SPOC'}
                    </p>
                </div>
                <p className="text-s text-gray-500 ">

                    {
                        SPOCProfileDetail?.userId ?
                            <> ID : {SPOCProfileDetail.userId} </>
                            : "SPOC ID generated will show here"
                    }
                </p>
            </div>
        </div>
    )
}